import { AbstractControl } from '@angular/forms';

export class PasswordValidation {

    static MatchPassword(AC: AbstractControl) {
        const password = AC.get('password').value; // to get value in input tag
        const passwordMatch = AC.get('passwordMatch').value; // to get value in input tag
        if (password !== passwordMatch) {
            AC.get('passwordMatch').setErrors({ MatchPassword: true });
        } else {
            return null;
        }
    }
}

